import { createApp, h } from 'vue';
import { IModalManager } from '@/types/modal/modal-manager.interface';
import { ModalManager } from '@studyportals/modal';
import { ModalStates } from '@/types/modal/modal.enum';
import { DispatchedEvents } from '@/types/dispatched-events';
import store from '@/store';
import RollbarOperator from '@/plugins/rollbar-operator';
import Bootstrapper from '@/bootstrapper';
import App from '@/presentation/app.vue';
import LogIn from '@/stand-alone/log-in/log-in.vue';
import StylesheetLoader from '@/stylesheet-loader';
import startUpHandler from '@/plugins/start-up-handler';

declare global {
	interface Window {
		ModalManager: IModalManager;
		Rollbar?: {
			error: (message: Error | string) => void;
			warn: (message: Error | string) => void;
		};
	}
}

window.ModalManager = new ModalManager();

startUpHandler.handleFirstStartUpActions();

const standAloneLogin = store.getters.standAloneLogin();
const placeholderSelector = '#GeoTargetingMS';
const contextIsUniAdmin = window.location.host.includes('administration');
const url = webpackDefinitions.VUE_APP_ICONSET_URL;

StylesheetLoader.loadStylesheet(url);

Bootstrapper.bootstrap()
	.then(() => {
		const app = createApp({
			render: () => {
				return h(App);
			}
		});

		RollbarOperator.handleVueErrors(app);

		app.mount(placeholderSelector);

		const isListingSession = store.getters.isListingSession();

		document.addEventListener(DispatchedEvents.GEOTARGETING_START_UP, () => {
			if (isListingSession) {
				return;
			}

			store.mutations.setModalState(ModalStates.ACTIVE);
		});

		document.dispatchEvent(new Event(DispatchedEvents.GEOTARGETING_MICROSERVICE_LOADED));

		if ((!standAloneLogin || contextIsUniAdmin) && !isListingSession) {
			return;
		}

		document.dispatchEvent(new Event(DispatchedEvents.GEOTARGETING_START_UP));
	})
	.catch((error: Error) => {
		if (!standAloneLogin || error.name !== 'NotAuthorizedException') {
			throw error;
		}

		const app = createApp({
			render: () => {
				return h(LogIn);
			}
		});

		app.mount(placeholderSelector);
	});
